import { Colors, Metrics, Typography } from "../../resources";
import { Orientation, SIconType } from "../../types";
import { StyleSheet, Text, TouchableOpacity } from "react-native";

import React from "react";
import SIcon from "./SIcon";
import SSpacer from "./SSpacer";

interface IProps {
  type: SIconType;
  title: string;
  size?: number;
  onPress: () => void;
}

const SIconLink: React.FC<IProps> = ({
  title,
  type,
  size = Metrics.iconSmall,
  onPress,
}) => {
  return (
    <TouchableOpacity style={styles.container} onPress={onPress}>
      <SIcon size={size} type={type} color={Colors.grey400} />
      <SSpacer type={Orientation.Horizontal} space={Metrics.padding8} />
      <Text style={styles.title}>{title}</Text>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: Metrics.padding16,
    paddingVertical: Metrics.paddingSmall10,
  },
  title: {
    ...Typography.headline2,
    color: Colors.grey400,
    target: "_blank",
  },
});

export default SIconLink;
